import { cx } from '@/utils';
import DotButton, { useDotButton } from '@common/DotButton/DotButton';

const CarouselDots = ({
  scrollSnaps,
  selectedIndex,
  onDotClick,
  dotClassName = 'dot !h-3 !w-3',
  selectedClassName,
}: {
  scrollSnaps: any[];
  selectedIndex: number;
  onDotClick: (index: number) => void;
  dotClassName?: string;
  selectedClassName?: string;
}) => (
  <div className="dots mt-2">
    {scrollSnaps.map((_, index) => (
      <DotButton
        key={index}
        onClick={() => onDotClick(index)}
        className={cx(dotClassName, index === selectedIndex ? selectedClassName : undefined)}
      />
    ))}
  </div>
);

export { useDotButton };

export default CarouselDots;
